import { props, state } from 'cerebral/tags'
import { set, equals, when, unset, merge } from 'cerebral/operators'
import setThumbnail from '../actions/setThumbnail'
import setPreview from '../actions/setPreview'
import removeFilesInView from './removeFilesInView'
import markAsDeletedInBasket from '../actions/markAsDeletedInBasket'
import onFilesCopied from '../chains/onFilesCopied'
import nodeChanged from './nodeChanged'
import setSelectedFiles from 'modules/Media/actions/setSelectedFiles'
import updateRestrictionInBasket from '../actions/updateRestrictionInBasket'
import setTagsForm from 'modules/Media/chains/setTagsForm'
import updateRestrictionInOrderHistory from '../actions/updateRestrictionInOrderHistory'
import updateAttestInOrderHistory from '../actions/updateAttestInOrderHistory'
import isCurrentFile from '../actions/isCurrentFile'
import loadDetails from 'modules/Media/actions/loadDetails'

const setStatus = (path, status) => {
  return [
    when(state`orderHistory.${path}.${props`payload.orderId`}`),
    {
      true: [
        set(
          state`orderHistory.history.${props`payload.orderId`}.status`,
          status
        ),
        when(props`payload.compressedFile`),
        {
          true: [
            set(
              state`orderHistory.history.${props`payload.orderId`}.compressedFile`,
              props`payload.compressedFile`
            )
          ],
          false: []
        }
      ],
      false: []
    }
  ]
}

export default [
  when(props`payload`),
  {
    true: [
      equals(props`payload.type`),
      {
        thumbnail: [setThumbnail],
        preview: setPreview,
        mediaCopied: [...onFilesCopied],
        mediaMoved: [...removeFilesInView],
        mediaDeleted: [
          set(props`payload.medias`, props`payload.ids`),
          ...removeFilesInView,
          markAsDeletedInBasket,
          setSelectedFiles
        ],
        nodeChanged: nodeChanged,
        orderDone: [
          ...setStatus('history', 'CLOSED'),
          ...setStatus('detail', 'CLOSED')
        ],
        orderFailed: [
          ...setStatus('history', 'FAILED'),
          ...setStatus('detail', 'FAILED')
        ],
        orderItemDone: [
          when(state`orderHistory.detail.${props`payload.orderItemId`}`),
          {
            true: [
              set(
                state`orderHistory.detail.${props`payload.orderItemId`}.destination.relativePath`,
                props`payload.destination.relativePath`
              )
            ],
            false: []
          }
        ],
        orderItemFailed: [
          when(state`orderHistory.detail.${props`payload.orderItemId`}`),
          {
            true: [
              set(
                state`orderHistory.detail.${props`payload.orderItemId`}.source.failedAt`,
                new Date().getTime()
              )
            ],
            false: []
          }
        ],
        orderRemoved: [
          when(state`orderHistory.history.${props`payload.orderId`}`),
          {
            true: [
              set(
                state`orderHistory.history.${props`payload.orderId`}.deletedAt`,
                props`payload.deletedAt`
              )
            ],
            false: []
          }
        ],
        restrictionChanged: [
          updateRestrictionInBasket,
          updateRestrictionInOrderHistory,
          function({ props, state }) {
            const { id, restriction } = props.payload
            state.set(
              `media.files.${id}.restrictionType`,
              restriction ? restriction.type : null
            )
            state.set(`media.files.${id}.restriction`, restriction || null)
          },
          isCurrentFile,
          {
            true: [...setTagsForm],
            false: []
          }
        ],
        orderItemAttested: [
          updateAttestInOrderHistory,
          when(props`payload.hasMoreItemsToAttestOnOrder`),
          {
            true: [],
            false: [
              unset(state`orderHistory.attestOrders.${props`payload.orderId`}`)
            ]
          }
        ],
        reloadMedia: [
          isCurrentFile,
          {
            true: [
              set(props`id`, props`payload.id`),
              set(state`media.tags.isLoading`, true),
              loadDetails,
              {
                loaded: [
                  merge(state`media.files.${props`id`}`, props`payload`),
                  set(state`media.tags.isLoading`, false),
                  ...setTagsForm
                ],
                error: []
              }
            ],
            false: [
              function({ props, state }) {
                const selectedFiles = state.get('media.selectedFiles')
                selectedFiles.forEach(fileId => {
                  if (fileId === props.payload.id) {
                    state.unset(`media.files.${fileId}.groups`) // marks reload
                  }
                })
              }
            ]
          }
        ],
        otherwise: []
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Socket/chains/eventRecieved.js